import PeopleIcon from '@mui/icons-material/People';
import { GuardedComponents } from '../../lib/permissions/types';
import { ResourceDefinition } from '../types';
import { UserCreate, UserEdit, UserList, UserShow } from '.';
import { error } from 'console';

export default {
  permissionResource: 'User',
  name: 'users',
  icon: PeopleIcon,
  components: new GuardedComponents([
    ['list', { action: 'GetList', component: UserList }],
    ['edit', { action: 'Update', component: UserEdit }],
    ['create', { action: 'Create', component: UserCreate }],
  ]),
  i18n: {
    nl: {
      name: 'Gebruiker |||| Gebruikers',
      fields: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        name: 'Naam',
        emailAddress: 'E-mailadres',
        phoneNumber: 'Telefoonnummer',
        isVerified: 'Geverifieerd',
        noRegions: 'Geen regios beschikbaar',
        password: "Wachtwoord",
        confirmPassword: "Bevestig wachtwoord",
        opened: "App aantal\nkeer geopend",
        lastOpened: "App laatst geopend\nop",
      },
      labels: {
        delete: 'Verwijderen',
        areYouSure: 'Weet je het zeker? Hiermee wordt de gebruiker verwijderd!',
        setPassword: 'Wachtwoord instellen',
        password_succesfully_set: 'Wachtwoord succesvol ingesteld.',
        error_setting_password: 'Er is een fout opgetreden bij het instellen van het wachtwoord. Probeer het opnieuw.',
        pleaseSetPassword: 'Voer eerst een wachtwoord in.',
        passwordsDoNotMatch: 'Wachtwoorden komen niet overeen.',
        cancel: 'Annuleren',
        password_requirements: 'Het wachtwoord moet voldoen aan de volgende eisen:',
      },
      validation: {
        minimum_length: "Dient uit minimaal 8 tekens te bestaan",
        one_digit: "Bevat ten minste 1 nummer",
        special_character: "Bevat ten minste 1 speciaal karakter",
        uppercase: "Bevat ten minste 1 hoofdletter",
        lowercase: "Bevat ten minste 1 kleine letter",
        error: "Wachtwoord voldoet niet aan de eisen",
      }
    },
  },
} as ResourceDefinition;
